import axios from '../axios/interceptor';

export const login = async (username, password) => {
    const response = await axios.post('/auth/login', { username, password });
    return response.data; 
}

export const signUp = async (userData) => {
    const response = await axios.post('/auth/sign-up', userData);
    return response.data; 
}

export const resetPassword = async (email) => {
    const response = await axios.post('/auth/reset-password', { email:email });
    return response.data; 
}

export const submitNewPassword = async (payload) => {
    const response = await axios.put('/auth/reset-password', payload);
    return response.data;  
}

export const fetchUserProfile = async () => {
    const response = await axios.get('/auth/user/profile');
    return response.data;  
}

export const updateUserProfile = async (userData) => {
    const response = await axios.put('/auth/user/profile', userData);
    return response.data;  
}

export const updateUserProfilePassword = async (userData) => {
    const response = await axios.put('/auth/user/profile/password', userData);
    return response.data;  
}